import { init, replayIntegration } from "@sentry/electron/renderer";
import { init as reactInit } from "@sentry/react";
import { Config } from "./config/index.ts";

if (Config.PROD && import.meta.env.VITE_SENTRY_DSN) {
	init(
		{
			dsn: import.meta.env.VITE_SENTRY_DSN,
			sendDefaultPii: true,
			integrations: [
				replayIntegration({
					maskAllText: false,
					blockAllMedia: false,
				}),
			],
			// Session Replay
			replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			replaysOnErrorSampleRate: 1.0,
		},
		reactInit,
	);
}
